import { PeriodFilterSelect, type PeriodFilterOption } from "@/components/ui/period-filter-select"
import { SearchInput } from "@/components/ui/search-input"
import { SegmentedFilter, type SegmentedFilterOption } from "@/components/ui/segmented-filter"
import { cn } from "@/lib/utils"

interface OrderFilterBarProps<TStatus extends string, TPeriod extends string> {
  statusValue: TStatus
  onStatusChange: (value: TStatus) => void
  statusOptions: SegmentedFilterOption<TStatus>[]
  periodValue: TPeriod
  onPeriodChange: (value: TPeriod) => void
  periodOptions: PeriodFilterOption<TPeriod>[]
  searchValue: string
  onSearchChange: (value: string) => void
  searchPlaceholder?: string
  className?: string
  controlsClassName?: string
  searchClassName?: string
  periodSelectClassName?: string
}

export function OrderFilterBar<TStatus extends string, TPeriod extends string>({
  statusValue,
  onStatusChange,
  statusOptions,
  periodValue,
  onPeriodChange,
  periodOptions,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  className,
  controlsClassName,
  searchClassName,
  periodSelectClassName,
}: OrderFilterBarProps<TStatus, TPeriod>) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
        className
      )}
    >
      <SegmentedFilter
        aria-label="Order status"
        value={statusValue}
        onValueChange={onStatusChange}
        options={statusOptions}
      />

      <div className={cn("flex flex-col gap-3 sm:flex-row sm:items-center", controlsClassName)}>
        <PeriodFilterSelect
          aria-label="Order period"
          value={periodValue}
          onValueChange={onPeriodChange}
          selectClassName={periodSelectClassName}
          options={periodOptions}
        />

        <SearchInput
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          className={searchClassName}
        />
      </div>
    </div>
  )
}
